/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Stack, Typography, useTheme } from "@mui/material";
import React from "react";

export const SeedStatsLabel = ({ title, value }: { title: string; value: string }) => {
  const theme = useTheme();
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Typography variant="body2" color={theme.colors.primary500} fontWeight="700">
        {title}
      </Typography>
      <Typography variant="body2" color={theme.colors.primary500}>
        {value}
      </Typography>
    </Stack>
  );
};
